import { Creative } from '../interfaces/entities/creative'
import { MultifileCreative } from './blueprints/creatives'
import {
  creativeReopens,
  creativeSent,
  creativeOutdated,
  creativeMigration,
} from './events'
import { emptyFormGuidelines } from '../interfaces/components/dynamic-form'

export const creatives: Creative[] = [
  {
    id: '21',
    formatsetId: '1',
    name: 'a nobis quo',
    type: { name: 'image', label: 'Image' },
    reopens: creativeReopens,
    sent: creativeSent,
    outdated: creativeOutdated,
    status: { name: 'archived', label: 'archived' },
    possibleActions: [
      { name: 'send_to_agency', label: 'Send To Agency' },
      { name: 'reopen', label: 'Reopen' },
      { name: 'delete', label: 'Delete' },
    ],
    comment: null,
    blueprint: MultifileCreative,
    blueprintMeta: {
      version: 'v1',
      outdated: false,
    },
    displayOrder: 1,
    data: {},
    tags: ['published'],
    guidelines: emptyFormGuidelines(),
    creativeMigration: creativeMigration,
  },

  {
    id: '1',
    formatsetId: '1',
    name: 'C1',
    type: { name: 'image', label: 'Image' },
    reopens: creativeReopens,
    sent: creativeSent,
    outdated: creativeOutdated,
    status: { name: 'sent_to_agency', label: 'sent_to_agency' },
    possibleActions: [
      { name: 'send_to_agency', label: 'Send To Agency' },
      { name: 'reopen', label: 'Reopen' },
      { name: 'delete', label: 'Delete' },
    ],
    blueprint: MultifileCreative,
    blueprintMeta: {
      version: 'v1',
      outdated: false,
    },
    data: {},
    comment: null,
    displayOrder: 2,
    tags: ['published'],
    guidelines: emptyFormGuidelines(),
    creativeMigration: creativeMigration,
  },
  {
    id: '2',
    formatsetId: '1',
    name: 'C2',
    type: { name: 'image', label: 'Image' },
    reopens: creativeReopens,
    sent: creativeSent,
    outdated: creativeOutdated,
    status: {
      name: 'work_in_progress',
      label: 'work_in_progress',
    },
    possibleActions: [
      { name: 'reopen', label: 'Reopen' },
      { name: 'delete', label: 'Delete' },
    ],
    blueprint: MultifileCreative,
    blueprintMeta: {
      version: 'v1',
      outdated: false,
    },
    data: {},
    comment: null,
    displayOrder: 3,
    tags: ['published'],
    guidelines: emptyFormGuidelines(),
    creativeMigration: creativeMigration,
  },
  {
    id: '3',
    formatsetId: '1',
    name: 'C3',
    type: { name: 'image', label: 'Image' },
    reopens: creativeReopens,
    sent: creativeSent,
    outdated: creativeOutdated,
    status: { name: 'sent_to_agency', label: 'sent_to_agency' },
    possibleActions: [],
    blueprint: MultifileCreative,
    blueprintMeta: {
      version: 'v1',
      outdated: false,
    },
    data: {},
    comment: null,
    displayOrder: 4,
    tags: ['published'],
    guidelines: emptyFormGuidelines(),
    creativeMigration: creativeMigration,
  },
  {
    id: '4',
    formatsetId: '1',
    name: 'C2A',
    type: { name: 'image', label: 'Image' },
    reopens: creativeReopens,
    sent: creativeSent,
    outdated: creativeOutdated,
    status: {
      name: 'specification_finalized',
      label: 'specification_finalized',
    },
    possibleActions: [
      { name: 'send_to_agency', label: 'Send To Agency' },
      { name: 'reopen', label: 'Reopen' },
    ],
    blueprint: MultifileCreative,
    blueprintMeta: {
      version: 'v1',
      outdated: false,
    },
    data: {},
    comment: null,
    displayOrder: 5,
    tags: ['published'],
    guidelines: emptyFormGuidelines(),
    creativeMigration: creativeMigration,
  },
]

export const nativeCreatives: Creative[] = [
  {
    id: '21',
    formatsetId: '2',
    name: 'a nobis quo',
    type: { name: 'image', label: 'Image' },
    reopens: creativeReopens,
    sent: creativeSent,
    outdated: creativeOutdated,
    status: { name: 'archived', label: 'archived' },
    possibleActions: [
      { name: 'send_to_agency', label: 'Send To Agency' },
      { name: 'reopen', label: 'Reopen' },
      { name: 'delete', label: 'Delete' },
    ],
    comment: null,
    blueprint: MultifileCreative,
    blueprintMeta: {
      version: 'v1',
      outdated: false,
    },
    displayOrder: 1,
    data: {},
    tags: ['published'],
    guidelines: emptyFormGuidelines(),
    creativeMigration: creativeMigration,
  },
]
